import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import MainLayout from 'components/MainLayout'
import { Container } from 'components/layout/Grid/'
import BackToAdminCentre from 'components/BackToAdminCentre'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { getPartnerPlanUploadRatings, deletePartnerPlanUploadRatings, sendNotification } from 'actions/partnerPlanRatingsUpload'
import { hasAccess } from 'utils/hasAccess'
import { getConfig } from 'utils/config'
import constants from 'constants'

class PartnerPlanRatingsUpload extends Component {
  static propTypes = {
    currentUser: PropTypes.object,
    deletePartnerPlanUploadRatings: PropTypes.func.isRequired,
    getPartnerPlanUploadRatings: PropTypes.func.isRequired,
    partnerPlanRatingsUpload: PropTypes.object.isRequired,
    routes: PropTypes.instanceOf(Array),
    sendNotification: PropTypes.func.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
  }
  static defaultProps = {
    routes: {},
    currentUser: null,
  }

  componentDidMount() {
    hasAccess(this.props.currentUser, 'ADMN: Partner Plan counselling rating upload', this.props.history, 'RW', true)
    this.props.getPartnerPlanUploadRatings(getConfig().PLAN_RATINGS, constants.PARTNERPLAN.RATINGSUPLOAD_FOLDER.CP)
  }

  bannerProps = () => {
    const {
      routes, history, location, match, path,
    } = this.props
    return {
      name: 'Admin centre',
      history,
      location,
      path,
      match,
      routes,
    }
  }

  render() {
    const {
      routes, partnerPlanRatingsUpload, currentUser,
    } = this.props

    return (
      <MainLayout bannerNavProps={{ ...this.bannerProps() }} showSidebar={false} sidebarType="partnerSideBar">
        <BackToAdminCentre displayText="Upload counselling partner plan ratings" isAdmin={this.props.currentUser.IsAdmin} />
        <Container>
          {routes.map((route, i) => (
            <RouteWithSubRoutes
              key={i}
              {...route}
              currentUser={currentUser}
              deletePartnerPlanRatings={this.props.deletePartnerPlanUploadRatings}
              initPartnerPlanRatings={this.props.getPartnerPlanUploadRatings}
              partnerPlanRatingsUpload={partnerPlanRatingsUpload}
              sendNotification={this.props.sendNotification}
              setErrorMessage={this.props.setErrorMessage}
            />
            ))}
        </Container>
      </MainLayout>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  partnerPlanRatingsUpload: state.partnerPlanRatingsUpload,
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  sendNotification,
  getPartnerPlanUploadRatings,
  deletePartnerPlanUploadRatings,
})(PartnerPlanRatingsUpload))



// WEBPACK FOOTER //
// ./src/containers/PartnerPlanRatingsUpload.js